import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLoggedInSilent, useUser } from '../../../store/reducers/user';
import { setEsiaUnsignedDocuments } from '../../../store/reducers/esia';
import { useIsPage } from '../../../store/selectors/selection';
import { mpl } from 'helpers/client';

/** Для авторизованных пользователей проверяем, есть ли неподписанные согласия */
export const useEsiaCheckUnsigned = () => {
    const user = useUser();
    const dispatch = useDispatch();
    const isLoggedInSilent = useLoggedInSilent();

    const { isMainPage, isMainCreditCardPage } = useIsPage();

    const enabled = !isLoggedInSilent && (isMainCreditCardPage || isMainPage) && Boolean(user);

    const getUnsignedDocs = useCallback(() => {
        mpl.checkUnsignedDocuments(true).then(({ docs }) => {
            if (docs && docs.length) {
                dispatch(setEsiaUnsignedDocuments(docs));
            }
        });
    }, [dispatch]);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        getUnsignedDocs();
    }, []);
};
